import React, { useContext, useMemo } from "react";
import add from "date-fns/add";
import sub from "date-fns/sub";
import styled from "styled-components";
import { StyledTile } from "manifest-components/src/Tiles/Tile";
import { ReactComponent as Pencil } from "manifest-components/src/Images/icons/Pencil.svg";
import LaunchDetails from "manifest-core/classes/employerDashboard/launchDetails";
import CheckboxMenuItem from "./menuItems/CheckboxMenuItem";
import { DevelopmentEnvironmentContext } from "../../context/DevelopmentEnvironment/developmentEnvironmentProvider";
import LocationStateDebugger from "./LocationStateDebugger";
import { isProdEnvironment } from "../../env";
import { UserContext } from "../../context/User/userProvider";

const CircleContainer = styled.div`
  position: fixed;
  z-index: 999;
  left: 30px;
  bottom: 10px;
  height: 60px;
  width: 60px;
  border-radius: 50%;
  background: rgb(157, 198, 189);
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    background: rgb(149, 190, 181);
  }

  svg {
    width: 50%;
    height: 50%;

    path {
      fill: #103930;
    }
  }

  @media (min-height: 741px) {
    bottom: 50px;
  }
`;

const DeveloperTools = () => {
  if (isProdEnvironment()) return null;

  const { state, toggleMenu } = useContext(DevelopmentEnvironmentContext);

  return (
    <>
      <CircleContainer role="button" onClick={() => toggleMenu()}>
        <Pencil />
      </CircleContainer>
      {state.showMenu ? <Menu /> : null}
      {state.showLocationState ? <LocationStateDebugger /> : null}
    </>
  );
};

/**
 * STYLING FOR MENU COMPONENT
 */

const MyTile = styled(StyledTile)`
  position: fixed;
  z-index: 999;
  bottom: 90px;
  left: 30px;
  width: 340px;
  cursor: auto;
  display: block;
  zoom: 80%;

  @media (min-height: 741px) {
    bottom: 130px;
  }
`;

const MenuContainer = styled.ul`
  width: 100%;
  height: 100%;
  list-style: none;
  padding: 0px;
  margin: 0px;
  display: grid;
  grid-gap: 16px;
`;

const Menu = () => {
  const { state, toggleLocationState } = useContext(DevelopmentEnvironmentContext);
  const { onboardingDetails, updateLaunchDetails, getLaunchDetails } = useContext(UserContext);

  const overrideLaunchDate = () => {
    if (!onboardingDetails || !onboardingDetails.launchDetails) return;

    if (onboardingDetails.launchDetails.isPrelaunched) {
      // if currently pre launch
      updateLaunchDetails(
        new LaunchDetails({
          ...onboardingDetails.launchDetails,
          launchDate: sub(new Date(), { weeks: 2 }),
        })
      );
    } else {
      // if currently post launch
      updateLaunchDetails(
        new LaunchDetails({
          ...onboardingDetails.launchDetails,
          launchDate: add(new Date(), { weeks: 2 }),
        })
      );
    }
    getLaunchDetails();
  };

  const canOverrideLaunchDate = useMemo(() => {
    if (!onboardingDetails || !onboardingDetails.launchDetails) return false;
    return !onboardingDetails.launchDetails.isPrelaunched;
  }, [onboardingDetails, onboardingDetails?.launchDetails]);

  return (
    <MyTile>
      <MenuContainer>
        <CheckboxMenuItem onClick={() => toggleLocationState()} enabled={state.showLocationState}>
          Show location state
        </CheckboxMenuItem>
        {onboardingDetails?.completed && (
          <CheckboxMenuItem onClick={() => overrideLaunchDate()} enabled={canOverrideLaunchDate}>
            Override to post launch
          </CheckboxMenuItem>
        )}
      </MenuContainer>
    </MyTile>
  );
};

export default DeveloperTools;
